"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.typed.uint8-array");
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
var _app = require("../../api/app.js");
var _login = require("../../api/login.js");
var _awsSdk = _interopRequireDefault(require("aws-sdk"));
var _axios = _interopRequireDefault(require("axios"));
var _browserMd5File = _interopRequireDefault(require("browser-md5-file"));
var _aliOss = _interopRequireDefault(require("ali-oss"));
var _jsMd = _interopRequireDefault(require("js-md5"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Appupload',
  data: function data() {
    return {
      isDisable: false,
      isFlag: true,
      dialogFormVisible: false,
      graySearchDisabled: true,
      tableData: [],
      currentRow: "",
      currentPage: 1,
      total: 0,
      auditingFlag: "",
      deployFlag: "",
      updateFlag: "",
      loading: false,
      isRepeat: false,
      disabledKeep: true,
      active: "",
      uplaodApp: "点击上传",
      transmissionParam: {
        id: 0,
        auditingFlag: ""
      },
      param: {
        appEnvironment: "",
        appName: "",
        appVersion: "",
        auditingFlag: "",
        deployFlag: "",
        pageNo: 1,
        pageSize: 10,
        updateFlag: ""
      },
      updateFlags: [{
        updateFlag: "",
        label: "所有"
      }, {
        updateFlag: "0",
        label: "不强制"
      }, {
        updateFlag: "1",
        label: "强制"
      }],
      auditingFlags: [{
        auditingFlag: "",
        label: "所有"
      }, {
        auditingFlag: "1",
        label: "待审核"
      }, {
        auditingFlag: "2",
        label: "通过"
      }, {
        auditingFlag: "3",
        label: "不通过"
      }],
      auditingFlagStatus: [{
        auditingFlag: "2",
        label: "通过"
      }, {
        auditingFlag: "3",
        label: "不通过"
      }],
      deployFlags: [{
        deployFlag: "",
        label: "所有"
      }, {
        deployFlag: "1",
        label: "待发布"
      }, {
        deployFlag: "2",
        label: "灰度"
      }, {
        deployFlag: "3",
        label: "发布"
      }, {
        deployFlag: "4",
        label: "不发布"
      }],
      dialogFormsVisible: false,
      formLabelWidth: "120px",
      //版本上传
      update: [{
        label: "不强制",
        value: "0"
      }, {
        label: "强制",
        value: "1"
      }],
      upload: {
        updateFlag: "",
        appName: "",
        appVersion: "",
        fileName: "",
        packageName: "",
        size: "",
        md5: "",
        innerName: ""
      },
      //灰度
      dialogGray: false,
      gray: {
        telephone: "",
        email: "",
        createTimeEnd: "",
        createTimeStart: "",
        isNormal: "",
        pageNo: 1,
        pageSize: 10,
        userName: ""
      },
      adgray: {
        id: "",
        userIdList: []
      },
      grayData: [],
      grayTable: [],
      grayRow: "",
      importFileUrl: "",
      fileNames: "",
      privateKey_1: "XAkWgD0A",
      privateKey_2: "KSVDWG",
      progress: 0,
      extension: false,
      value: null,
      keyId: "K66NRBmhuzqh6QX36ICAKIAVT4",
      secretId: "zlMc+UDjkbfloun7DrYRHfJQNupFNQfZuKHd49NL8jqu2x",
      ufileKeyId: "DZ6AMdbKW54tdbbnzqikFxwHYPAJ4ZDugctlNo9",
      ufileSecretId: "DY2OpDusgX65jFGrbqcqs9bCLLp6DkpenI6VCxKzZ7pRlO6Hdt",
      md5: ""
    };
  },
  //刷新
  created: function created() {
    this.getList();
  },
  methods: {
    //点击获取当前点击行的数据
    getRow: function getRow(row) {
      this.currentRow = row;
      this.transmissionParam.id = row.id;
      this.auditingFlag = row.auditingFlag;
      this.deployFlag = row.deployFlag;
      this.updateFlag = row.updateFlag;
    },
    getList: function getList() {
      var _this = this;
      this.param.auditingFlag = "";
      this.loading = true;
      setTimeout(function () {
        (0, _app.searchAppVersion)(_this.param).then(function (res) {
          _this.tableData = res.voList;
          _this.total = res.total;
          //把原来选中行的数据清除
          _this.currentRow = "";
          _this.transmissionParam.id = "";
          _this.auditingFlag = "";
          _this.deployFlag = "";
          _this.updateFlag = "";
          _this.loading = false;
          _this.isRepeat = false;
        });
      }, 1000);
    },
    //每页显示的条数
    changepage: function changepage(currentPage) {
      this.currentPage = currentPage;
      this.param.pageNo = currentPage;
      this.getList();
    },
    //根据参数进行查询
    search: function search() {
      var _this2 = this;
      //参数查询数据
      this.loading = true;
      setTimeout(function () {
        (0, _app.searchAppVersion)({
          appEnvironment: _this2.param.appEnvironment,
          appName: _this2.param.appName,
          appVersion: _this2.param.appVersion,
          auditingFlag: _this2.param.auditingFlag,
          deployFlag: _this2.param.deployFlag,
          pageNo: 1,
          pageSize: 10,
          updateFlag: _this2.param.updateFlag
        }).then(function (res) {
          _this2.tableData = res.voList;
          _this2.total = res.total;
          _this2.currentPage = 1;
          _this2.loading = false;
        });
      }, 500);
    },
    //清空
    empty: function empty() {
      this.param.appEnvironment = "";
      this.param.appName = "";
      this.param.appVersion = "";
      this.param.auditingFlag = "";
      this.param.deployFlag = "";
      this.param.updateFlag = "";
      this.getList();
    },
    updateFlagFormat: function updateFlagFormat(row, column) {
      if (row.updateFlag == "0") {
        return "不强制";
      } else if (row.updateFlag == "1") {
        return "强制";
      }
    },
    auditingFlagFormat: function auditingFlagFormat(row, column) {
      if (row.auditingFlag == "1") {
        return "待审核";
      } else if (row.auditingFlag == "2") {
        return "通过";
      } else if (row.auditingFlag == "3") {
        return "不通过";
      }
    },
    deployFlagFormat: function deployFlagFormat(row, column) {
      if (row.deployFlag == "1") {
        return "待发布";
      } else if (row.deployFlag == "2") {
        return "灰度";
      } else if (row.deployFlag == "3") {
        return "发布";
      } else if (row.deployFlag == "4") {
        return "不发布";
      }
    },
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    },
    //下载
    download: function download() {
      var _this3 = this;
      if (this.currentRow == "" || this.currentRow == null) {
        this.msgTip("error", "请选择需要下载的记录");
      } else {
        if (this.isFlag) {
          this.isFlag = false;
          (0, _app.download)(this.transmissionParam.id).then(function (res) {
            if (res.success) {
              window.location.href = res.url;
            }
            if (!res.success) {
              _this3.$message({
                type: "warning",
                message: res.errorMsg,
                center: true
              });
            }
            _this3.isFlag = true;
            _this3.getList();
          });
        }
      }
    },
    //删除
    del: function del() {
      var _this4 = this;
      if (this.currentRow == "" || this.currentRow == null) {
        this.msgTip("error", "请选择需要删除的记录");
      } else {
        if (this.auditingFlag != "1" || this.deployFlag != "1") {
          this.$message({
            type: "warning",
            message: "仅能删除待发布且未审核的版本",
            center: true
          });
        } else {
          this.$confirm("您是否要删除当前选中的记录?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            //进行删除
            (0, _app.deleteApp)(_this4.transmissionParam.id).then(function (res) {
              if (res.success) {
                _this4.$message({
                  type: "success",
                  message: "操作成功",
                  center: true
                });
                _this4.getList();
              } else {
                //删除失败
                _this4.$message({
                  type: "warning",
                  message: "操作失败",
                  center: true
                });
              }
            });
          });
        }
      }
    },
    //撤销
    undo: function undo() {
      var _this5 = this;
      if (this.currentRow == "" || this.currentRow == null) {
        this.msgTip("error", "请选择需要撤销的记录");
      } else {
        if (this.deployFlag != "3") {
          this.$message({
            type: "warning",
            message: "仅能撤销发布的版本",
            center: true
          });
        } else {
          if (this.isFlag) {
            this.isFlag = false;
            //撤销操作
            (0, _app.undo)(this.transmissionParam.id).then(function (res) {
              if (res.success) {
                _this5.$message({
                  type: "success",
                  message: "操作成功",
                  center: true
                });
                // 获取当前日期时间
                (0, _app.dataManipulation)(_this5.tableData, _this5.currentRow, "", 4, getDate());
                _this5.isFlag = true;
              } else {
                //删除失败
                _this5.$message({
                  type: "warning",
                  message: "操作失败",
                  center: true
                });
                _this5.isFlag = true;
              }
            });
          }
        }
      }
    },
    //审核点击按钮
    audit: function audit() {
      if (this.currentRow == "" || this.currentRow == null) {
        this.msgTip("error", "请选择需要审核的记录");
      } else {
        if (this.auditingFlag != "1" || this.deployFlag != "2") {
          this.$message({
            type: "warning",
            message: "仅能审核状态为待审核及发布状态是灰度的版本",
            center: true
          });
        } else {
          //显示审核框
          this.dialogFormVisible = true;
          this.isDisable = false;
        }
      }
    },
    //审核修改事件
    save: function save() {
      var _this6 = this;
      if (this.param.auditingFlag == null || this.param.auditingFlag == "") {
        this.$message({
          type: "warning",
          message: "审核操作不能为空",
          center: true
        });
      } else {
        //把下拉框的值赋值给传输对象
        this.transmissionParam.auditingFlag = this.param.auditingFlag;
        this.isRepeat = true;
        this.isDisable = true;
        (0, _app.audit)(this.transmissionParam).then(function (res) {
          if (res.success) {
            _this6.$message({
              type: "success",
              message: "操作成功",
              center: true
            });
            _this6.auditingFlag = "2";
            // 获取当前日期时间
            (0, _app.dataManipulation)(_this6.tableData, _this6.currentRow, _this6.transmissionParam.auditingFlag, "", getDate());
            _this6.dialogFormVisible = false;
          } else {
            _this6.$message({
              type: "warning",
              message: "操作失败",
              center: true
            });
            _this6.isRepeat = false;
            _this6.isDisable = false;
          }
        });
      }
    },
    //发布
    deploy: function deploy() {
      var _this7 = this;
      if (this.currentRow == "" || this.currentRow == null) {
        this.msgTip("error", "请选择需要发布的记录");
      } else {
        if (this.auditingFlag != "2" || this.deployFlag != 2) {
          this.$message({
            type: "warning",
            message: "仅能发布灰度且审核通过的版本",
            center: true
          });
        } else {
          if (this.isFlag) {
            this.isFlag = false;
            (0, _app.deploy)(this.transmissionParam.id).then(function (res) {
              if (res.success) {
                _this7.$message({
                  type: "success",
                  message: "操作成功",
                  center: true
                });
                _this7.deployFlag = "3";
                // 获取当前日期时间
                (0, _app.dataManipulation)(_this7.tableData, _this7.currentRow, "", "3", getDate());
                _this7.dialogFormVisible = false;
                _this7.isFlag = true;
              } else {
                _this7.$message({
                  type: "warning",
                  message: "操作失败",
                  center: true
                });
                _this7.isFlag = true;
              }
            });
          }
        }
      }
    },
    //版本上传
    appupload: function appupload() {
      this.upload.updateFlag = "";
      this.upload.appName = "";
      this.upload.appVersion = "";
      this.upload.fileName = "";
      this.upload.packageName = "";
      this.upload.updateFlag = "";
      this.upload.md5 = "";
      this.upload.size = "";
      this.upload.innerName = "";
      this.uplaodApp = "点击上传";
      this.disabledKeep == true;
      this.dialogFormsVisible = true;
      this.progress = 0;
    },
    submitUpload: function submitUpload() {
      var _this8 = this;
      console.log("你好可酷伯", this.$refs.uploadFile.files[0]);
      var fileData = this.$refs.uploadFile.files[0];
      this.selectedFile = fileData;
      var formFile = new FormData();
      formFile.append("file", fileData);
      var index = fileData.name.lastIndexOf(".");
      var str = fileData.name.substring(index + 1, fileData.name.length);
      if (str === "apk" || str === "ipa") {
        this.extension = true;
      }
      if (this.extension = false) {
        this.msgTip("error", "上传文件只能是apk 或 ipa 格式!");
        this.loading = false;
        this.$refs.uploadFile.value = null;
      }
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
      (0, _app.getCheckUpload)({
        fileName: fileData.name
      }).then(function (res) {
        if (res.success) {
          _this8.$refs.uploadFile.value = null;
          _this8.upload.fileName = res.voT.fileName;
          // this.upload.appName = res.voT.appName;
          _this8.upload.appVersion = res.voT.appVersion;
          _this8.upload.packageName = res.voT.packageName;
          _this8.upload.size = fileData.size;
          _this8.loading = false;
          _this8.disabledKeep = false;
        } else {
          _this8.msgTip("error", res.errorMsg);
          _this8.loading = false;
          _this8.$refs.uploadFile.value = null;
          return;
        }
      });
      this.getFileMD5(fileData).then(function (md5) {
        _this8.upload.md5 = md5;
        (0, _app.appAapply)({
          fileName: fileData.name,
          folder: "1"
        }).then(function (res) {
          if (res.success) {
            _this8.fileNames = res.s3Url.substr(res.s3Url.lastIndexOf("/", res.s3Url.lastIndexOf("/") - 1) + 1);
            console.log("文件名", _this8.fileNames);
            _this8.upload.innerName = _this8.fileNames;
            if (userType == "cn") {
              var data = {
                file: fileData,
                fileRename: _this8.fileNames
              };
              //ali云上传
              console.log("ali云上传");
              var _accessKeyId = _this8.decryption(res.accessKeyId);
              var accessKeySecret = _this8.decryption(res.accessKeySecret);
              var bucket = res.bucketName;
              var clientOssAli = new _aliOss.default({
                accessKeyId: _accessKeyId,
                accessKeySecret: accessKeySecret,
                bucket: bucket,
                endpoint: "supernote.com.cn"
              });
              var innerName1 = _this8.fileNames;
              console.log(innerName1);
              //调用阿里云Oss上传方法
              _this8.startUpload(fileData, clientOssAli, innerName1);
            } else {
              console.log("aws 云上传");
              var decryptedPart1 = _this8.keyId.slice(-7);
              var decryptedPart2 = _this8.keyId.slice(-14, -7).split("").reverse().join("");
              var decryptedPart3 = _this8.keyId.slice(0, -14).slice(0, -6).split("").reverse().join("");
              var accessKeyId = decryptedPart1 + decryptedPart2 + decryptedPart3;
              var secretdecryptedPart1 = _this8.secretId.slice(-15);
              var secretdecryptedPart2 = _this8.secretId.slice(-31, -15).split("").reverse().join("");
              var secretreversedPart3 = _this8.secretId.slice(0, -31).slice(0, -6).split("").reverse().join("");
              var secretAccessKey = secretdecryptedPart1 + secretdecryptedPart2 + secretreversedPart3;
              console.log("secretAccessKey", secretAccessKey);
              var s3 = new _awsSdk.default.S3({
                accessKeyId: accessKeyId,
                secretAccessKey: secretAccessKey,
                region: "ap-northeast-1"
              });
              var _bucket = res.bucketName;
              var params = {
                Bucket: _bucket,
                Key: _this8.fileNames,
                ContentType: _this8.selectedFile.type,
                ACL: "public-read"
              };
              s3.getSignedUrl("putObject", params, function (error, url) {
                if (error) {
                  console.error("获取预签名URL失败：", error);
                  return;
                }
                var xhr = new XMLHttpRequest();
                xhr.open("PUT", url, true);
                xhr.setRequestHeader("Content-Type", _this8.selectedFile.type);
                xhr.upload.addEventListener("progress", function (event) {
                  if (event.lengthComputable) {
                    console.log("上传进度:", Math.round(event.loaded / event.total * 100));
                    _this8.progress = Math.round(event.loaded / event.total * 100);
                    if (event.loaded / event.total * 100 == 100) {}
                  }
                });
                xhr.onreadystatechange = function () {
                  if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                      console.info("文件上传成功");
                      _this8.uplaodApp = "已上传";
                    } else {
                      console.error("文件上传失败：", xhr.statusText);
                    }
                  }
                };
                xhr.send(_this8.selectedFile);
              });
            }
          }
        });
        // this.loading = true;
      }).catch(function (error) {
        console.error("Error calculating MD5:", error);
      });
    },
    //阿里云OSS上传
    startUpload: function () {
      var _startUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(fileData, clientOssAli, innerName1) {
        var _this9 = this;
        var result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return clientOssAli.multipartUpload("/" + innerName1,
              // 目标Bucket中的文件路径
              fileData,
              // 本地文件路径
              {
                progress: function progress(percent) {
                  console.log("\u4E0A\u4F20\u8FDB\u5EA6: ".concat(Math.round(percent * 100), "%"));
                  _this9.progress = Math.round(percent * 100);
                }
              });
            case 3:
              result = _context.sent;
              console.log("上传成功:", result);
              this.uplaodApp = "已上传";
              _context.next = 14;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("UploadError:", _context.t0);
              this.loading = false;
              this.$refs.uploadFile.value = null;
              this.msgTip("error", "上传文件失败！");
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 8]]);
      }));
      function startUpload(_x, _x2, _x3) {
        return _startUpload.apply(this, arguments);
      }
      return startUpload;
    }(),
    // 解密函数
    decryption: function decryption(encryptionStr) {
      if (encryptionStr === null || encryptionStr === "") {
        return encryptionStr;
      }
      var decryptedStr = "";
      var length = Math.ceil(encryptionStr.length / 2);
      for (var i = 0; i < length; i++) {
        var charCode = parseInt(encryptionStr.substring(i * 2, i * 2 + 2), 16) - 1;
        decryptedStr += String.fromCharCode(charCode);
      }
      var startIndex = this.privateKey_1.length;
      var endIndex = decryptedStr.length - this.privateKey_2.length;
      endIndex = Math.max(endIndex, 0);
      return decryptedStr.substring(startIndex, endIndex);
    },
    // 更新上传进度
    updateUploadProgress: function updateUploadProgress(fileName, progressEvent) {
      var progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      this.msgList = this.msgList.map(function (item) {
        if (item.fileName === fileName) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            progress: progress
          });
        }
        return item;
      });
    },
    //计算MD5
    getFileMD5: function () {
      var _getFileMD = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(file) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function () {
                  var buffer = new Uint8Array(reader.result);
                  var hash = (0, _jsMd.default)(buffer);
                  resolve(hash);
                };
                reader.onerror = reject;
                reader.readAsArrayBuffer(file);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getFileMD5(_x4) {
        return _getFileMD.apply(this, arguments);
      }
      return getFileMD5;
    }(),
    submitUpload_1: function submitUpload_1() {
      var _this10 = this;
      var fileData = this.$refs.uploadFile.files[0];
      var formFile = new FormData();
      formFile.append("file", fileData);
      this.loading = true;
      (0, _app.getCheckUpload)(formFile).then(function (res) {
        if (res.success) {
          _this10.msgTip("success", "上传成功");
          _this10.uplaodApp = "已上传";
          _this10.$refs.uploadFile.value = null;
          _this10.upload.fileName = res.voT.fileName;
          // this.upload.appName = res.voT.appName;
          _this10.upload.appVersion = res.voT.appVersion;
          _this10.upload.packageName = res.voT.packageName;
          _this10.loading = false;
          _this10.disabledKeep = false;
        } else {
          _this10.msgTip("error", res.errorMsg);
          _this10.loading = false;
          _this10.$refs.uploadFile.value = null;
        }
      });
    },
    keep: function keep() {
      var _this11 = this;
      if (this.upload.updateFlag == "") {
        this.msgTip("warning", "请选择是否强制！");
      } else if (this.upload.appName == "") {
        this.msgTip("warning", "应用名称不能为空");
        return false;
      } else {
        if (this.disabledKeep == true) {
          return;
        }
        this.isRepeat = true;
        this.loading = true;
        this.disabledKeep = true;
        (0, _app.getUpload)(this.upload).then(function (res) {
          if (res.success) {
            _this11.dialogFormsVisible = false;
            _this11.loading = false;
            _this11.msgTip("success", "版本上传成功！");
            _this11.$refs.uploadFile.value = [];
            _this11.empty();
          } else {
            _this11.msgTip("error", res.errorMsg);
            _this11.$refs.uploadFile.value = [];
            _this11.loading = false;
            _this11.isRepeat = false;
          }
        });
      }
    },
    //灰度
    grays: function grays() {
      if (this.currentRow == "" || this.currentRow == null) {
        this.msgTip("error", "请选择需要灰度的记录！");
      } else {
        this.grayTable = [];
        this.querGrayById(this.currentRow.id);
        this.grayData = [];
        this.dialogGray = true;
        this.graySearchDisabled = true;
        this.gray.telephone = "";
        this.gray.email = "";
      }
    },
    querGrayById: function querGrayById(id) {
      var _this12 = this;
      (0, _app.querGray)(id).then(function (res) {
        if (res.success) {
          _this12.grayTable = res.voList;
        } else {
          _this12.msgTip("error", res.errorMsg);
        }
      });
    },
    //灰度查询
    graySearch: function graySearch() {
      var _this13 = this;
      (0, _login.getUsercontrol)(this.gray).then(function (res) {
        if (res.success) {
          _this13.grayData = res.voList;
        } else {
          _this13.msgTip("error", res.errorMsg);
        }
      });
    },
    //灰度清空
    grayEmpty: function grayEmpty() {
      this.gray.telephone = "";
      this.gray.email = "";
      this.graySearchDisabled = true;
    },
    //灰度添加
    addGray: function addGray() {
      var _this14 = this;
      if (this.grayRow == "") {
        this.msgTip("warning", "请选择需要添加的记录！");
      } else {
        this.adgray.id = this.currentRow.id;
        (0, _app.addGray)(this.adgray).then(function (res) {
          if (res.success) {
            _this14.deployFlag = 2;
            _this14.querGrayById(_this14.currentRow.id);
            _this14.adgray.userIdList = [];
            // 获取当前日期时间
            (0, _app.dataManipulation)(_this14.tableData, _this14.currentRow, "", 2, getDate());
          } else {
            _this14.msgTip("error", res.errorMsg);
          }
        });
      }
    },
    //灰度删除
    dele: function dele(row) {
      var _this15 = this;
      (0, _app.delGray)(row.id).then(function (res) {
        if (res.success) {
          (0, _app.querGray)(_this15.currentRow.id).then(function (res) {
            if (res.success) {
              _this15.grayTable = res.voList;
            } else {
              _this15.msgTip("error", res.errorMsg);
            }
          });
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.grayRow = val;
      for (var i = 0; i < val.length; i++) {
        this.adgray.userIdList.push(val[i].userId);
      }
    },
    getInputGray: function getInputGray(event) {
      if (this.gray.telephone != "" || this.gray.email != "") {
        this.graySearchDisabled = false;
      } else {
        this.graySearchDisabled = true;
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    },
    handleClick: function handleClick(row) {
      console.log(row);
    }
  }
};
/**
 * 获取当前时间
 */
function getDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  var hours = date.getHours(); //获取当前小时数(0-23)
  var minutes = date.getMinutes(); //获取当前分钟数(0-59)
  var seconds = date.getSeconds();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hours + ":" + minutes + ":" + seconds;
  return currentdate;
}